import { Component, OnInit ,ViewChild} from '@angular/core';
import { NgForm } from "@angular/forms";
import { DateAdapter } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from "@angular/common";
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import { ChequeService } from "./shared/cheque.service";

@Component({
  selector: 'app-cheque',
  templateUrl: './cheque.component.html',
  styleUrls: ['./cheque.component.css']
})
export class ChequeComponent implements OnInit {

  AddButtonText: string = "Save";
  dataSourceList = new MatTableDataSource<any>();
 @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  ParentChequeNo: number;
  BranchList: [''];
  BankList:[''];

  constructor(private router: Router,private activatedRoute:ActivatedRoute,public chequeService: ChequeService) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe(param => {
      this.ParentChequeNo = + param['Id'];  //Parent ChequeNo
    });

    this.resetForm();
    this.GetBranchList();
    this.GetBankList();
    
    this.dataSourceList.paginator = this.paginator;

    if (Number.isNaN(this.ParentChequeNo)) {
      this.chequeService.selectedCheque.Id = 0;
      this.chequeService.selectedCheque.Flag = 1;
      this.chequeService.selectedCheque.IsActive = 1;
      this.AddButtonText = "Save";
    }
    else {
      this.chequeService.selectedCheque.Id = +this.ParentChequeNo;
      this.chequeService.selectedCheque.Flag = 2;
      this.AddButtonText = "Edit & Save";

      this.GetChequeByChequeNo();
    }
  }

  resetForm(form?: NgForm) {
    if (form != null)
      form.reset();

    this.chequeService.selectedCheque = {
      Id   : null,
      BranchId   : 0,
      BranchName: null,
      BankId   : 0, 
      BankName: null,
      ChequeStartNo   : null,
      ChequeNumbers   : null,	
      EmployeeId   : null,
      CompanyBranchId   : null,
      CompanyId   : null,
      SaasId   : null,
      IsActive: 1,
      Flag: 1,
    }
  }

  public onSubmit(form: NgForm) {

    this.chequeService.IUDCheque(form.value)
      .subscribe(data => {
        this.resetForm(form);
        this.router.navigate(['/chequelist']);
      })
  }

  GetChequeByChequeNo() {

    if (!Number.isNaN(this.ParentChequeNo)) {
      // this.chequeService.selectedCheque.Id = this.ParentChequeNo;
      this.chequeService.FetchChequeByChequeNo(this.chequeService.selectedCheque).subscribe(data => {

        this.chequeService.selectedCheque = data;
        this.chequeService.selectedCheque.Id=+data.Id;
        this.chequeService.selectedCheque.Flag = 2;
      })
    }
  }
  
  GetBranchList() {
    this.chequeService.GetBranchList().subscribe(data => {
      this.BranchList = data;
    })
  }

  GetBankList(){
    this.chequeService.GetBankList().subscribe(data => {
      this.BankList = data;
    })
  }

}
